import { Box, Typography, TypographyProps, useTheme } from "@mui/material";

const Body = ({ variant, ...otherProps }: TypographyProps) => {
  const theme = useTheme();

  if (theme.name === "inline") {
    return <Box component="p" {...otherProps} />;
  }

  return <Typography variant={variant ?? "body1"} {...otherProps} />;
};

export default Body;
